module.exports = __webpack_public_path__ + "img/sage-1.f3feffa7.webp";